var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import urls from './urls';
import * as d3 from 'd3-dsv';
const data = {};
for (const name of Object.keys(urls)) {
    const url = urls[name];
    const f = function () {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield fetch(url);
            if (name.endsWith('.json')) {
                return yield result.json();
            }
            else if (name.endsWith('.csv')) {
                // TODO: remove "as any" once @types/d3-dsv has been updated
                return d3.csvParse(yield result.text(), d3.autoType);
            }
            else {
                return yield result.text();
            }
        });
    };
    f.url = url;
    data[name] = f;
}
export default data;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0YS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9kYXRhLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLE9BQU8sSUFBSSxNQUFNLFFBQVEsQ0FBQztBQUMxQixPQUFPLEtBQUssRUFBRSxNQUFNLFFBQVEsQ0FBQztBQUk3QixNQUFNLElBQUksR0FBeUUsRUFBUyxDQUFDO0FBRTdGLEtBQUssTUFBTSxJQUFJLElBQUssTUFBTSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQVksRUFBRTtJQUM5QyxNQUFNLEdBQUcsR0FBRyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDdkIsTUFBTSxDQUFDLEdBQVE7O1lBQ1gsTUFBTSxNQUFNLEdBQUcsTUFBTSxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUM7WUFFaEMsSUFBSSxJQUFJLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQyxFQUFFO2dCQUN4QixPQUFPLE1BQU0sTUFBTSxDQUFDLElBQUksRUFBRSxDQUFDO2FBQzlCO2lCQUFNLElBQUksSUFBSSxDQUFDLFFBQVEsQ0FBQyxNQUFNLENBQUMsRUFBRTtnQkFDOUIsNERBQTREO2dCQUM1RCxPQUFPLEVBQUUsQ0FBQyxRQUFRLENBQUMsTUFBTSxNQUFNLENBQUMsSUFBSSxFQUFFLEVBQUcsRUFBVSxDQUFDLFFBQVEsQ0FBQyxDQUFDO2FBQ2pFO2lCQUFNO2dCQUNILE9BQU8sTUFBTSxNQUFNLENBQUMsSUFBSSxFQUFFLENBQUM7YUFDOUI7UUFDTCxDQUFDO0tBQUEsQ0FBQTtJQUNELENBQUMsQ0FBQyxHQUFHLEdBQUcsR0FBRyxDQUFDO0lBQ1osSUFBSSxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQztDQUNsQjtBQUVELGVBQWUsSUFBSSxDQUFDIn0=